import * as React from 'react';

import styles from './charts.module.css';

type PayloadValues = {
    bucket: string;
    count: number;
};

type PayloadType = {
    active: boolean;
    payload: {
        payload: PayloadValues[];
    };
};

type Props = {
    payload: PayloadType;
    singlularNoun: string;
    pluralNoun: string;
};

export const DonutChartTooltip = (props: Props) => {
    // @ts-expect-error
    const payload = props.payload.active ? props.payload.payload[0] : undefined;

    if (payload) {
        const {bucket, count} = payload.payload;

        return (
            <div className={styles['tooltip-container']}>
                <div>{bucket}</div>
                <strong>
                    {count.toLocaleString()} {count === 1 ? props.singlularNoun : props.pluralNoun}
                </strong>
            </div>
        );
    }

    return <></>;
};
